import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const KIT_URL = 'https://digital-solvex-ar.myshopify.com/cart/48681186394369:1';

// --- CAMBIO AQUÍ: Agregamos el mensaje predeterminado ---
const PHONE = '5491135779682';
const WA_MESSAGE = '¡Hola! Vi la página del Kit de Mercado Libre y quiero saber si funciona para mi rubro. ¿Me podrían asesorar?';
const WA_URL = `https://wa.me/${PHONE}?text=${encodeURIComponent(WA_MESSAGE)}`;
// --------------------------------------------------------

export function WhatsAppButton() {
  const [showMobileCTA, setShowMobileCTA] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  useEffect(() => {
    function handleScroll() {
      setShowMobileCTA(window.scrollY > 700);
    }
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Mostrar el tooltip después de 3 segundos y repetir cada 10 segundos
  useEffect(() => {
    const show = setTimeout(() => setShowTooltip(true), 3000);
    const hide = setTimeout(() => setShowTooltip(false), 7000);
    const interval = setInterval(() => {
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 4000);
    }, 10000);
    return () => {
      clearTimeout(show);
      clearTimeout(hide);
      clearInterval(interval);
    };
  }, []);
  return <>
      {/* WhatsApp FAB con glow y tooltip */}
      <div className="fixed bottom-6 right-6 z-50 md:bottom-8 md:right-8 flex flex-col items-end gap-3" data-id="element-256">

        {/* Mensaje flotante */}
        <AnimatePresence data-id="element-257">
          {showTooltip && <motion.div initial={{
          opacity: 0,
          x: 16,
          scale: 0.9
        }} animate={{
          opacity: 1,
          x: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          x: 16,
          scale: 0.9
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} className="flex items-center gap-2 bg-white text-navy font-semibold text-sm px-4 py-2.5 rounded-2xl shadow-xl" style={{
          maxWidth: 220,
          whiteSpace: 'nowrap'
        }} data-id="element-258">
              {/* Burbuja de chat */}
              <span className="text-[#25D366] text-lg" data-id="element-259">💬</span>
              <span data-id="element-260">¿Tenés una duda?</span>
              {/* Flecha apuntando al botón */}
              <div style={{
            position: 'absolute',
            right: -8,
            bottom: 12,
            width: 0,
            height: 0,
            borderTop: '7px solid transparent',
            borderBottom: '7px solid transparent',
            borderLeft: '8px solid white'
          }} data-id="element-261" />
            </motion.div>}
        </AnimatePresence>

        {/* Botón WhatsApp con glow pulsante */}
        <a href={WA_URL} target="_blank" rel="noopener noreferrer" aria-label="Contactar por WhatsApp" onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)} style={{
        position: 'relative',
        display: 'inline-flex'
      }} data-id="element-262">
          {/* Anillo de glow exterior — pulso lento */}
          <span style={{
          position: 'absolute',
          inset: -6,
          borderRadius: '50%',
          background: 'rgba(37, 211, 102, 0.25)',
          animation: 'wa-pulse 2s ease-out infinite'
        }} data-id="element-263" />
          {/* Anillo secundario — pulso desfasado */}
          <span style={{
          position: 'absolute',
          inset: -3,
          borderRadius: '50%',
          background: 'rgba(37, 211, 102, 0.18)',
          animation: 'wa-pulse 2s ease-out infinite 0.6s'
        }} data-id="element-264" />
          {/* Botón principal */}
          <span style={{
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 56,
          height: 56,
          borderRadius: '50%',
          background: '#25D366',
          boxShadow: '0 4px 20px rgba(37, 211, 102, 0.55)',
          transition: 'transform 0.2s, box-shadow 0.2s'
        }} className="hover:scale-110" data-id="element-265">
            {/* Ícono WhatsApp SVG */}
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="28" height="28" data-id="element-266">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-267" />
            </svg>
          </span>
        </a>
      </div>

      {/* Keyframes del glow */}
      <style data-id="element-268">{`
        @keyframes wa-pulse {
          0%   { transform: scale(1);   opacity: 0.7; }
          70%  { transform: scale(1.6); opacity: 0;   }
          100% { transform: scale(1.6); opacity: 0;   }
        }
      `}</style>

      {/* Mobile Sticky CTA */}
      <AnimatePresence data-id="element-269">
        {showMobileCTA && <motion.div initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 100,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-navy-dark/95 backdrop-blur-sm border-t border-gold/20 p-3" style={{
        paddingBottom: 'calc(0.75rem + env(safe-area-inset-bottom))'
      }} data-id="element-270">
            <a href={KIT_URL} className="btn-gold block w-full text-center py-3.5 rounded-xl font-extrabold text-sm no-underline" data-id="element-271">
              Kit Completo — $62.900 →
            </a>
          </motion.div>}
      </AnimatePresence>
    </>;
}